export default function LetterCircle({
  letter,
  selected,
  onStart,
  onEnter,
}) {
  return (
    <g
      transform={`translate(${letter.x}, ${letter.y})`}
      onPointerDown={() => onStart(letter)}
      onPointerEnter={() => onEnter(letter)}
      className="cursor-pointer"
    >

      <circle
        r="11"
        fill={selected ? "#fb923c" : "url(#letterBg)"}
        /* stroke="#f97316" */
      />

      <text
        x="0"
        y="1"
        textAnchor="middle"
        dominantBaseline="middle"
        className="puzzle-game-font"
      >
        {letter.char}
      </text>
    </g>
  );
}